import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { PurchaseAdminResponse, PurchasesAdminParams } from './types';

export async function getPurchasesAdmin(params: PurchasesAdminParams = {}) {
  const url = '/web/studio/purchases';

  const queryParams: Record<string, string | number> = {};

  if (params.userQuery) queryParams.user_query = params.userQuery;
  if (params.limit !== undefined) queryParams.limit = params.limit;
  if (params.offset !== undefined) queryParams.offset = params.offset;

  const response = await api.executeGetRequest<PaginatedListResponse<PurchaseAdminResponse>>(url, queryParams);

  return response;
}
